import '../css/stylesheet.css';
import '../fonts/fontsheet.css';
import Window from "../Window"

function Resume({ setWindows }){
    return (
        <Window windowName="Resume" setWindows={setWindows}>
            <div style={{
                margin: "0.2em",
                padding: "0.1em",
                border: "4px solid #000000",
                boxSizing: "border-box",
                backgroundColor: "#FFFFFF", height: "99%"
            }}>
                <div style={{
                    margin: "0.1em",
                    padding: "0.5em",
                    border: "1px solid #000000",
                    boxSizing: "border-box",
                    overflowY: "auto", height: "99%"
                }}>
                    <h1>Ishan Sharma</h1>
                    <p><b>Email: </b>ishan.sharma.acc@gmail.com</p>
                    <p><b>Phone: </b>(628) 758 1556</p>
                    <p><b>Degree: </b>Bachelors of Applied Mathematics, University of Waterloo (2017-2022)</p>
                    <h2>Summary of Qualifications</h2>
                    <ul>
                        <li>2+ years of experience with 3 hyper-growth startups (AI, FinTech, B2B Process Automation) </li>
                        <li>Proactive problem solver with bias-for-action. </li>
                        <li>Experience in designing and developing microservices and APIs for scale and with Site-Reliability-Engineering. </li>
                    </ul>
                    <p>
                        <b>Tech Stack: </b>
                        JavaScript (Node.js), RabbitMQ, Postgres, AWS (S3, EC2, ELB, VPC), Redis, ScyllaDB, Rust, Mesos/K8, Jenkins, Grafana, ELK, Python, C#, C++, Swift, Java and PHP 
                    </p>
                    <p>
                        <b>Certifications: </b>
                        Microsoft Azure AI-102, Azure AI-900, Microsoft Professional C# (70-483), & AWS (CCP)
                    </p>
                    <h2>Experience</h2>
                    <div>
                        <p>
                            <u><b>Software Engineer</b> for FDM Group (Nov 2023 to June 2024)</u><br/>
                            <i>Real-world application for a system for trainer management</i></p>
                        <ul>
                            <li>Helped design and perfect a scalable system for managing, adding, updating, and viewing volume of documents.</li>
                            <li>Worked within deadlines to perform and complete tasks for the system.</li>
                            <li>Create management systems for organization of the update process</li>
                            <li>Determined truth of personal information through verification processes</li>
                        </ul>
                        <p><b>Tech Stack:</b> Angular, Javascript, Spring Boot, Java, SQL</p><br/>
                    </div>
                    <div>
                        <p>
                            <u><b>Software Engineer</b> for Hive AI (Oct 2022 to June 2023)</u><br/>
                            <i>SaaS providing AI-based content moderation for platforms such as Reddit and Imgur</i></p>
                        <ul>
                            <li>Designed and developed scalable and performant APIs for a distributed system that processes billions of inference requests per month for machine learning classification.</li>
                            <li>Took ownership of stabilizing the platform by implementing highly-scalability features such as sharding and distributed-keys (with ScyllaDB) and migrated the backend services to quorum queue (RabbitMQ).</li>
                            <li>To allow for platform debugging, added API logging and fixed scalability issues </li>
                            <li>Provided on-call support to resolve issues such as performance of production environment under tremendous load, payment transaction issues, client-authentication and new client onboarding</li>
                            <li>Worked with Product Managers, Architects to prioritize features in daily scrums and implement them.</li>
                        </ul>
                        <p><b>Tech Stack:</b> Javascript (Node), Rust, Marathon, Mesos, RabbitMQ, Postgres, Scylla</p><br/>
                    </div>
                    <div>
                        <p>
                            <u><b>Software Engineer (Intern)</b> for Remitbee Inc. (Jan 2021 to Aug 2021)</u><br/>
                            <i>FinTech for international money transfer: Web-app, iOS-app and Android-app</i></p>
                        <ul>
                            <li>COVID led to rapid expansion of the platform from 3 countries to 47 </li>
                            <li>Introduced measures for developer effectiveness like unit-test coverage</li>
                            <li>Took ownership of automated testing & automated business process testing to flag Financial Fraud scenarios</li>
                            <li>Developed tests that checked financial operations from the client side to ensure they functioned properly</li>
                            <li>Examined builds of the application and reviewed code for bugs (such as OWASP top-10)</li>
                        </ul>
                        <p><b>Tech Stack:</b> Selenium, Azure, React, Bitbucket, Uniteller, Thunes, MySQL</p><br/>
                    </div>
                    <div>
                        <p>
                            <u><b>Software Engineer (Intern)</b> for Loopio Inc. (Sep 2019 to Dec 2019)</u><br/>
                            <i>B2B Process automation SaaS. Market-leader to automate RFP responses in scale </i></p>
                        <ul>
                            <li>Joined when Loopio was facing customer churn to competitors and needed to pivot and modernize</li>
                            <li>Worked with Product Managers, Architects to prioritize features in daily Scrums </li>
                            <li>Fixed defects that could not be fixed by other interns such as search and scalable performance </li>
                            <li>Developed UI-tests to automate CI/CD and security tests for authentication and authorization </li>
                        </ul>
                        <p><b>Tech Stack:</b> AWS, React, Jenkins, BitBucket, Codeception, Selenium, MySQL</p><br/>
                    </div>
                    <div>
                        <p><u><b>Software Engineer (Intern)</b> for Kinectrics Inc. (Jan 2019 to Apr 2019)</u><br/></p>
                        <ul>
                            <li>Designed and developed application to automate spectrometers submission to Federal Government</li>
                            <li>Designed data-models with an entity-relationship model and developed and deployed the app. to production</li>
                        </ul>
                        <p><b>Tech Stack:</b> C#, VBA, ftp, MSSQL Server</p>
                    </div>
                </div>
            </div>
        </Window>
    );
}

export default Resume;